import Component from "vue-class-component"
import { faCheck, faCircleNotch, faTimes } from "@fortawesome/free-solid-svg-icons"

import { Container, Item } from "@skinsoft/types"
import { ReactiveVue } from "@skinsoft/reactive-vue"
import { ContainerCard } from "@skinsoft/entity-ui"
import { Touchable } from "@skinsoft/ui"
import { ListContentType } from "../list-content-type"
import { ContainerItemCard } from "./container-item-card"

require('./container-item-list.scss')

type DeletableContainerContent = (Item | Container) & { isBeingDeleted?: boolean }

@Component({
    components: {
        sTouchable: Touchable,
        sContainerItemCard: ContainerItemCard,
        sContainerCard: ContainerCard
    },
    props: {
        items: Array,
        contentType: String,
        titleKey: String,
        updating: Boolean
    },
    template: require('./container-item-list.html')
})
export class ContainerItemList extends ReactiveVue {
    private items: DeletableContainerContent[]
    private contentType: ListContentType
    private titleKey: string
    private updating: boolean

    private deleting: boolean = false

    public checkIcon = faCheck
    public crossIcon = faTimes
    public spinnerIcon = faCircleNotch

    private readonly ListContentType = ListContentType

    private onLongPress(itemIndex: number) {
        this.deleting = false
        this.$emit('display-overlay', itemIndex, this.contentType)
    }

    private onCancel() {
        this.$emit('cancel-deletion')
    }

    private onDelete(item: DeletableContainerContent) {
        this.deleting = true
        this.$emit('delete', item)
    }
}